// @ts-nocheck
import React, { useContext } from 'react';
import appConst from '../Utilities/appConst.json';
import ShippingMethod from './ShippingMethod';
import Asafta from './Asafta';
import Shops from './Shops';
import ShippingMethodExtraData from './ShippingMethodExtraData';
import type { ShippingOption } from '../Types/shipping';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../context/language/LanguageContext';

type ShippingMethodAccordionProps = {
    id: string | number;
    index: number;
    option: ShippingOption;
    isChecked: boolean;
    wasSelectionMade: boolean;
    product?: string | null;
    expandedPanel?: boolean;
    onChange?: ((event: React.SyntheticEvent, isExpanded: boolean) => void) | null;
    onClick?: (option: ShippingOption) => void;
    testId?: string;
};

const ShippingMethodAccordion = (props: ShippingMethodAccordionProps) => {
    const languageContext = useContext(LanguageContext);
    const isNewsletter = useSelector((state: any) => state.user.isNewsletter);

    const price = parseFloat(String(props.option.price));
    const priceForClubMember = parseFloat(String(props.option.priceForClubMember));
    const hasDiscount = isNewsletter && price > priceForClubMember;

    const shippingMethodsDetails = [
        {
            id: appConst.ASAFTA,
            elemnt:
                <>
                    <Asafta />
                    <ShippingMethodExtraData id={appConst.ASAFTA} />
                </>
        },
        {
            id: appConst.BHSHOPS,
            elemnt:
                <>
                    <Shops />
                    <ShippingMethodExtraData id={appConst.BHSHOPS} />
                </>
        },
        {
            id: appConst.REGISTERED,
            elemnt:
                <>
                    <ShippingMethodExtraData id={appConst.REGISTERED} />
                </>
        },
        {
            id: appConst.BHHOME,
            elemnt:
                <>
                    <ShippingMethodExtraData id={appConst.BHHOME} />
                </>
        }
    ];

    const shippingMethodDetail = shippingMethodsDetails.find(shippingMethodDetail => shippingMethodDetail.id == props.id);
    const element = shippingMethodDetail ? shippingMethodDetail.elemnt : <></>;
    const hasExpandedContent = Boolean(shippingMethodDetail) || hasDiscount;

    return (
        <div
            className="mx-3 w-auto overflow-hidden rounded-[6px] border border-lupa-border-soft bg-white shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:mx-auto md:w-full"
            data-testid={props.testId}
        >
            <div
                className="w-full"
                aria-expanded={props.expandedPanel ? "true" : "false"}
            >
                <ShippingMethod
                    onClick={props.onClick}
                    wasSelectionMade={props.wasSelectionMade}
                    option={props.option}
                    key={props.index}
                    isChecked={props.isChecked}
                    product={props.product}
                    testId={props.testId ? `${props.testId}-button` : undefined}
                />
            </div>

            {props.expandedPanel && hasExpandedContent && (
                <div
                    className="w-full border-t border-lupa-border-soft bg-white"
                    data-testid={props.testId ? `${props.testId}-details` : undefined}
                >
                    <div className="w-full bg-white">
                        {hasDiscount && (
                            <div className="box-border w-full px-4 pt-3">
                                <div className="flex w-full items-center justify-between py-1.5">
                                    <span className="font-ploni text-sm text-secondary-foreground md:text-lg">
                                        {languageContext.getTranslation(appConst.SHIPPING_PRICELIST)}:
                                    </span>
                                    <span className="font-ploni text-sm text-secondary-foreground md:text-lg">
                                        ₪{price.toFixed(2)}
                                    </span>
                                </div>
                                <div className="flex w-full items-center justify-between py-1.5">
                                    <span className="font-ploni text-sm text-secondary-foreground md:text-lg">
                                        {languageContext.getTranslation(appConst.NEWSLETTER_EMAIL_DISCOUNT)}:
                                    </span>
                                    <span className="font-ploni text-sm text-secondary-foreground md:text-lg">
                                        ₪{priceForClubMember.toFixed(2)}
                                    </span>
                                </div>
                                <div className="my-2 h-px bg-lupa-border-soft" />
                            </div>
                        )}
                        {element}
                    </div>
                </div>
            )}
        </div>
    )
}
export default ShippingMethodAccordion;
